import { useState } from "react";
import { Navbar } from "@/components/site/Navbar";
import { Hero } from "@/components/site/Hero";
import { Ribbon } from "@/components/site/Ribbon";
import { Services } from "@/components/site/Services";
import { BeforeAfter } from "@/components/site/BeforeAfter";
import { Manifesto } from "@/components/site/Manifesto";
import { Reviews } from "@/components/site/Reviews";
import { Booking } from "@/components/site/Booking";
import { Footer } from "@/components/site/Footer";
import { useScrollTo } from "@/lib/smooth-scroll";

export default function Home() {
  const [formule, setFormule] = useState("");
  const scrollTo = useScrollTo();

  const selectFormule = (name) => {
    setFormule(name);
    scrollTo("#reservation");
  };

  return (
    <div className="bg-[var(--bg-0)] min-h-screen">
      <Navbar />
      <Hero />
      <Ribbon />
      <Services onSelect={selectFormule} />
      <BeforeAfter />
      <Manifesto />
      <Reviews />
      <Booking formule={formule} setFormule={setFormule} />
      <Footer />
    </div>
  );
}
